import { render } from "./Error.vue?vue&type=template&id=93cb7644&scoped=true"
const script = {}

import "./Error.vue?vue&type=style&index=0&id=93cb7644&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93cb7644"]])

export default __exports__